import { defineTool } from '@/shell/tool';

/** SMS Blast (Flutter `/users/sms-blast`). */
export default defineTool({
  id: 'sms-blast',
  title: 'SMS Blast',
  summary:
    'Text the Monday deals or accounts your filters match, now or scheduled.',
  section: 'operations',
  order: 40,
  icon: 'chat_bubble',
  owner: '@Drabu',
  permission: 'sms-blast:use',
  routes: () => import('./SmsBlastPage'),
});
